/**
 * Projects Masonry Block JavaScript
 * Handles touchscreen detection and visibility adjustments
 */
document.addEventListener('DOMContentLoaded', function () {
	function isTouchDevice() {
		return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
	}

	// Make hocus elements always visible on touch devices
	if (isTouchDevice()) {
		const hocusElements = document.querySelectorAll('[data-hocus-force-visible]');

		hocusElements.forEach(function (element) {
			element.classList.remove('md:opacity-0');
		});
	}
});
